<template>
  <el-dialog width="40%" ref="dialog" :visible.sync="visible">
    <div slot="title">{{ title }}</div>

    <div>{{ message }}</div>

    <v-row slot="footer" justify="center">
      <v-button theme="primary" @click="close">{{ $t('c.dialog.buttonClose') }}</v-button>
    </v-row>
  </el-dialog>
</template>

<script>
import VRow from '@/components/common/VRow.vue'
import visibleMixin from '@/mixins/visible@deprecated'

export default {
  name: 'VNotificationDialog',

  mixins: [visibleMixin],
  components: { VRow },

  props: {
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  }
}
</script>
